import React from 'react';
import CommonFilter from '../components/CommonFilter';
import SteamPurchaseAnalysis from './SteamPurchaseAnalysis';
import SteamGameDuration from './SteamGameDuration';
import SteamFeedsReviewsDetailed from '../components/SteamFeedsReviewsDetailed';
import steamPerformancePoint from '@op/operationLog/pages/steamPerformanceInsights';
export default function Insights() {
  return (
    <CommonFilter
      steamPerformancePoint={steamPerformancePoint}
      title={'Insights'}
    >
      {({ filter }) => {
        return (
          <>
            <SteamPurchaseAnalysis filter={filter}></SteamPurchaseAnalysis>
            <SteamGameDuration filter={filter}></SteamGameDuration>
            <SteamFeedsReviewsDetailed
              filter={filter}
              statsLanguageDetailType={'steam-insights-language'}
              statsDetailType={'steam-performance-keyword-insights'}
            ></SteamFeedsReviewsDetailed>
          </>
        );
      }}
    </CommonFilter>
  );
}
